<template>
  <div class="cat__core__step mb-4" v-bind:class="[ `cat__core__step--${color}` ]">
    <span class="cat__core__step__digit"><i :class="icon"></i></span>
    <div class="cat__core__step__desc">
      <span class="h3 font-weight-bold mb-0">{{ title }}</span>
      <p>{{ desc }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'dashboard-tile',
    props: ['title', 'desc', 'icon', 'color'],
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/layout/DashboardTile.vue